import React from "react";

const Container = ({ children }) => {
  return <div className="mx-auto max-w-[1280px] lg:px-[20px] xl:px-[30px] px-[18px] ">{children}</div>;
}; 

export default Container;

